import { Popover as AntPopover } from 'antd'
import type { ComponentProps } from 'react'

type AntPopoverProps = ComponentProps<typeof AntPopover>

export interface AppPopoverProps extends AntPopoverProps {
  onVisibleChange?: (open: boolean) => void
}

export const AppPopover = ({ onVisibleChange, onOpenChange, ...rest }: AppPopoverProps) => (
  <AntPopover onOpenChange={onVisibleChange ?? onOpenChange} {...rest} />
)
